import ApiService from "../../../ApiService";

const ListService = {
    loadScreenView: (SearchErrorInVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/error/list/loadscreenview", { SearchErrorInVO }, successCallback, failureCallback);
    },

    delete: (id, successCallback, failureCallback) => {
        ApiService.get(`/web/admin/error/details/${id}/delete`, null, successCallback, failureCallback);
    },

    clearAll: (successCallback, failureCallback) => {
        ApiService.get("/web/admin/error/list/clearall", null, successCallback, failureCallback);
    },

    loadApiScreenView: (SearchErrorInVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/error/list/loadapiscreenview", { SearchErrorInVO }, successCallback, failureCallback);
    },

    deleteApi: (id, successCallback, failureCallback) => {
        ApiService.get(`/web/admin/error/details/${id}/deleteapierror`, null, successCallback, failureCallback);
    },

    clearApiAll: (successCallback, failureCallback) => {
        ApiService.get("/web/admin/error/list/clearallapierror", null, successCallback, failureCallback);
    },

    getAuth: (userId, successCallback, failureCallback) => {
        ApiService.get(`/mobile/admin/loginUser?id=${userId}`,null, successCallback, failureCallback);
    },

    replayApiError: (error, authorization, successCallback, failureCallback) => {
        ApiService.replayApiError(error.requestMethod, authorization, error.requestHeaders, error.requestUrl, error.requestBody, successCallback, failureCallback);
    },
};

export default ListService;
